export { ButtonWrapper as Button } from './Button/button';
export { Body, ContentfulBody } from './Body/body';
export { ContentfulLegalBody } from './Body/Legal/legalBody';
export { BlogBody } from './Body/Blog/blogBody';
// export { Icon } from "./Icon/icon";
export { Label as Text } from './Label/label';
export { Radio } from './Radio/radio';
